<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Leave Policies</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]"><i class="ti ti-smart-home"></i></a>
          </li>
          <!-- <li class="breadcrumb-item">
              Employee
            </li> -->
          <li class="breadcrumb-item active" aria-current="page">Leave Policies</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="mb-2 me-2">
        <button
          (click)="openBusiness(addBusinessModal)"
          *appHasPermission="{ leavePolicy: ['add'] }"
          class="btn btn-primary d-flex align-items-center"
        >
          <i class="ti ti-circle-plus me-2"></i>Add Policy
        </button>
      </div>
      <div class="mb-2">
        <button
          (click)="openBusiness(assignPolicyModal)"
          *appHasPermission="{ leavePolicy: ['add'] }"
          class="btn btn-primary d-flex align-items-center"
        >
          <i class="ti ti-circle-plus me-2"></i>Assign Policy
        </button>
      </div>
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Leave Policy List</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3" *ngIf="policyList.length > 0">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>
        <!-- <div class="dropdown me-3">
          <select
            class="form-select"
            [(ngModel)]="selectedBusiness"
            (change)="getLeavePolicyList()"
          >
            <option value="" selected>Select Business Entity</option>
            <option *ngFor="let business of businesses$ | async" [value]="business.id">
              {{ business.businessName | capitalize }}
            </option>
          </select>
        </div> -->
        <ng-select
          class="me-3"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="selectedBusiness"
          (change)="getLeavePolicyList()"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>
        <div class="form-sort search-box">
          <label>
            <input
              type="search"
              [(ngModel)]="search"
              (input)="getLeavePolicyList()"
              class="form-control"
              placeholder="Search"
          /></label>
        </div>
        <!-- Rest of your template -->
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <table class="table datatable" *ngIf="policyList.length > 0; else noRecords">
          <thead class="thead-light">
            <tr>
              <!-- <th class="no-sort">
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox" id="select-all">
                  </div>
                </th> -->
              <th>Title</th>
              <th>Date</th>
              <th>Description</th>
              <th>Business Entity</th>
              <!-- <th>Status</th> -->
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let policy of policyList">
              <!-- <td>
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox">
                  </div>
                </td> -->
              <td>
                <h6 class="fw-medium">
                  {{ policy.title }}
                </h6>
                <span class="fs-12">{{ policy.leaveType | capitalize }}</span>
              </td>
              <!-- <td>{{ holiday.startDate | date: 'EEE, dd MMM yyyy' }}{{ holiday.endDate != holiday.startDate ? to holiday.endDate | date: 'EEE, dd MMM yyyy' : ''}}</td> -->
              <td>
                {{ policy.date | date: 'EEE, dd MMM yyyy' }}
                <!-- <span *ngIf="holiday.endDate !== holiday.startDate"> <strong>to</strong> {{ holiday.endDate | date: 'EEE, dd MMM yyyy' }}</span> -->
              </td>
              <td class="text-wrap">{{ policy.description }}</td>
              <td>{{ policy.business.businessName | capitalize }}</td>
              <!-- <td>
                  <span *ngIf="holiday.status == 'Active'"
                    class="badge badge-success d-inline-flex align-items-center badge-xs">
                    <i class="ti ti-point-filled me-1"></i>Active
                  </span>
                  <span *ngIf="holiday.status != 'Active'"
                    class="badge badge-danger d-inline-flex align-items-center badge-xs">
                    <i class="ti ti-point-filled me-1"></i>Inactive
                  </span>
                </td> -->
              <td>
                <div class="action-icon d-inline-flex">
                  <a [routerLink]="['/leaves/assigned-policy-detail', policy.id]" class="me-2"
                    ><i class="ti ti-eye"></i
                  ></a>
                  <a
                    href="javascript:void(0);"
                    class="me-2"
                    (click)="openEditPolicy(editBusinessModal, policy)"
                    *appHasPermission="{ leavePolicy: ['edit'] }"
                    ><i class="ti ti-edit"></i
                  ></a>
                  <!-- <a href="javascript:void(0);" class="me-2"
                      (click)="openBlockUnblock(blockunblockModal, holiday.id, holiday.title , holiday.status)"><i
                        [ngClass]="holiday.status == 'Inactive' ? 'ti ti-lock' : 'ti ti-lock-open-2'"></i></a> -->
                  <!-- <a href="javascript:void(0);" class="me-2" (click)="setAsDefault(policy)"
                    ><i
                      class="ti ti-star"
                      [ngClass]="policy.isDefault ? 'text-warning' : 'text-muted'"
                    ></i>
                  </a> -->
                  <a
                    href="javascript:void(0);"
                    class="me-2"
                    (click)="setAsDefault(policy)"
                    *appHasPermission="{ leavePolicy: ['edit'] }"
                    ><i
                      [ngClass]="
                        policy.isDefault ? 'ti ti-star-filled filled text-primary' : 'ti ti-star'
                      "
                    ></i>
                  </a>
                  <!-- <a href="javascript:void(0);" class="me-2"
                    ><i
                      class="ti ti-star"
                      [ngClass]="policy.isDefault ? 'fas fa-star : 'far fa-star'"
                    ></i>
                  </a> -->
                  <ng-container *appHasPermission="{ leavePolicy: ['delete'] }">
                    <a
                      href="javascript:void(0);"
                      (click)="openDelete(deleteModal, policy.id)"
                      *ngIf="policy.assignedCount === 0"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </ng-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- <div class="has-text-centered mt-3" *ngIf="policyList.length > 0">
        <app-pagination [currentPage]="currentPage" [pageSize]="pageLimit" [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"></app-pagination>
      </div> -->
    <div
      class="d-flex align-items-center justify-content-between ms-2"
      *ngIf="policyList.length > 0"
    >
      <div>
        Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
        {{ totalCount }} entries
      </div>
      <div class="has-text-centered mt-3">
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="pageLimit"
          [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"
        ></app-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Add Holiday -->
<ng-template #addBusinessModalss let-modal>
  <!-- <div class="modal fade" id="add_holiday">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Add Leave Policy</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="title" class="form-label">Title <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="title" appTrimInput />
            <div *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('title') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="leaveType" class="col-form-label"
                >Leave Type <span class="text-danger">*</span></label
              >
              <select class="form-select" formControlName="leaveType">
                <option value="" selected>Select Type</option>
                <option *ngFor="let leave of leaveTypes" [value]="leave">
                  {{ leave }}
                </option>
                <!-- <option [value]="leaveTypeEnum.LeaveWithoutPay">
                  {{ leaveTypeEnum.LeaveWithoutPay }}
                </option>
                <option [value]="leaveTypeEnum.Casual">{{ leaveTypeEnum.Casual }}</option>
                <option [value]="leaveTypeEnum.Sick">{{ leaveTypeEnum.Sick }}</option> -->
              </select>
              <div *ngIf="form.get('leaveType')?.invalid && form.get('leaveType')?.touched">
                <span class="text-danger">
                  {{ getErrorMessage('leaveType') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label for="date" class="form-label"
              >Effective From <span class="text-danger">*</span></label
            >
            <!-- <div class="input-icon-end position-relative"> -->
            <input
              type="date"
              class="form-control datetimepicker"
              placeholder="dd/mm/yyyy"
              formControlName="date"
              appTrimInput
            />
            <!-- <span class="input-icon-addon">
                  <i class="ti ti-calendar text-gray-7"></i>
                </span> -->
            <!-- </div> -->
            <div *ngIf="form.get('date')?.invalid && form.get('date')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('date') }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="businessId" class="col-form-label"
                >Business Entity <span class="text-danger">*</span></label
              >
              <!-- <select class="form-select" formControlName="businessId">
                <option disabled selected>Select Business Entity</option>
                <option *ngFor="let business of businesses$ | async" [value]="business.id">
                  {{ business.businessName | capitalize }}
                </option>
              </select> -->
              <ng-select
                class="me-3 w-100"
                [items]="businesses$ | async"
                bindValue="id"
                placeholder="Select Business Entity"
                formControlName="businessId"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFn"
                style="width: 200px"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
              </ng-select>
              <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
                <span class="text-danger">
                  {{ getErrorMessage('businessId') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <textarea
              class="form-control"
              rows="3"
              formControlName="description"
              appTrimInput
            ></textarea>
            <div *ngIf="form.get('description')?.invalid && form.get('description')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('description') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12 d-none">
          <div class="mb-3">
            <label for="status" class="form-label">Status</label>
            <select class="form-select" formControlName="disabled">
              <option>Active</option>
              <option>Inactive</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="!form.valid">
        Add Leave Policy
      </button>
    </div>
  </form>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /Add Holiday -->

<!-- create leave policy -->
<ng-template #addBusinessModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Create Leave Policy</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Accrual Rules</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 3"
          (click)="stepChange(3)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 3"
            >Reset Rules</a
          >
        </li>

        <!-- <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 4"
          (click)="stepChange(4)"
          *ngIf="!hideOtherFields"
        > -->
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 4"
          (click)="stepChange(4)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 4"
            >Application Constraints</a
          >
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <form [formGroup]="form">
        <fieldset *ngIf="currentStep === 1" id="first-field" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="businessId" class="col-form-label"
                      >Business Entity <span class="text-danger">*</span></label
                    >
                    <ng-select
                      class="me-3 w-100"
                      [items]="businesses$ | async"
                      bindValue="id"
                      placeholder="Select Business Entity"
                      [searchable]="true"
                      [clearable]="true"
                      [searchFn]="customSearchFn"
                      style="width: 200px"
                      formControlName="businessId"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.businessName | capitalize }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.businessName | capitalize }}
                      </ng-template>
                    </ng-select>
                    <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
                      <span class="text-danger">
                        {{ getErrorMessage('businessId') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="title" class="form-label"
                    >Policy Name <span class="text-danger">*</span></label
                  >
                  <input type="text" class="form-control" formControlName="title" appTrimInput />
                  <div *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
                    <span class="text-danger">
                      {{ getErrorMessage('title') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="description" class="form-label"
                    >Description <span class="text-danger">*</span></label
                  >
                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="description"
                    appTrimInput
                  ></textarea>
                  <div *ngIf="form.get('description')?.invalid && form.get('description')?.touched">
                    <span class="text-danger">
                      {{ getErrorMessage('description') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="leaveType" class="col-form-label"
                      >Leave Type <span class="text-danger">*</span></label
                    >
                    <select class="form-select" formControlName="leaveType">
                      <option value="" selected>Select Type</option>
                      <option *ngFor="let leave of leaveTypes" [value]="leave">
                        {{ leave }}
                      </option>
                    </select>
                    <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
                      <span class="text-danger">
                        {{ getErrorMessage('businessId') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="date" class="form-label"
                    >From which date should this policy be effective?
                    <span class="text-danger">*</span></label
                  >
                  <p class="text-body-tertiary fs-12">
                    The leave accrual for any assigned employee will start from either this
                    (effective from) date or date of joining, whichever is later.
                  </p>
                  <input
                    type="date"
                    class="form-control"
                    formControlName="date"
                    appTrimInput
                    [min]="2000 - 01 - 01"
                  />
                  <div *ngIf="form.get('date')?.invalid && form.get('date')?.touched">
                    <span class="text-danger">
                      {{ getErrorMessage('date') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Do you want the policy to be encashable?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="workhoursyes"
                      [value]="true"
                      formControlName="encashable"
                    />
                    <label class="form-check-label" for="workhoursyes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="workhoursno"
                      [value]="false"
                      formControlName="encashable"
                    />
                    <label class="form-check-label" for="workhoursno"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 2" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="accrualMethod" class="col-form-label"
                      >What is the accrual method? <span class="text-danger">*</span></label
                    >
                    <p class="text-body-tertiary fs-12">
                      Accrual refers to how many leaves are allotted every period out of the total
                      leaves allotted annually. Leaves can be earned proportionally on each pay
                      period throughout the year or all at once. AVR HRMS suggests that "throughout
                      every period" is the best option.
                    </p>
                    <select class="form-select" formControlName="accrualMethod">
                      <option value="Throughout Every Period">Throughout Every Period</option>
                      <option value="Unlimited">Unlimited</option>
                    </select>

                    <div
                      *ngIf="
                        form.get('accrualMethod')?.invalid && form.get('accrualMethod')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('accrualMethod') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="form.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="totalPerYear" class="form-label"
                    >Total Per Year <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    min="0"
                    max="365"
                    class="form-control"
                    formControlName="totalPerYear"
                    appTrimInput
                    [class.bg-light]="form.get('accrualMethod')?.value === 'Unlimited'"
                    [class.text-muted]="form.get('accrualMethod')?.value === 'Unlimited'"
                  />
                  <div
                    *ngIf="form.get('totalPerYear')?.invalid && form.get('totalPerYear')?.touched"
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('totalPerYear') }}
                    </span>
                  </div>
                  <!-- this code is added by shivam -->
                  <div *ngIf=""></div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="form.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="accrualFrequency" class="col-form-label"
                      >What do you want to be the accrual frequency?
                      <span class="text-danger">*</span></label
                    >

                    <select class="form-select" formControlName="accrualFrequency">
                      <!-- <option value="Weekly">Weekly</option> -->
                      <option value="Monthly">Monthly</option>
                      <option value="Quaterly">Quaterly</option>
                      <option value="Half Yearly">Half Yearly</option>
                      <option value="Annually">Annually</option>
                      <!-- <option>None</option> -->
                    </select>

                    <div
                      *ngIf="
                        form.get('accrualFrequency')?.invalid &&
                        form.get('accrualFrequency')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('accrualFrequency') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="form.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="accrualHappenPeriod" class="form-label col-lg-12"
                    >Does accrual happen at the beginning or at the end of the period?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="accrualHappenPeriodStart"
                      [value]="true"
                      [disabled]="form.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="accrualHappenPeriod"
                    />
                    <label class="form-check-label" for="accrualHappenPeriodStart">
                      Beginning of the period
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="accrualHappenPeriodEnd"
                      [value]="false"
                      [disabled]="form.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="accrualHappenPeriod"
                    />
                    <label class="form-check-label" for="accrualHappenPeriodEnd">
                      End of the period
                    </label>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="form.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Is there a waiting period before leaves starts accruing?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="probationPeriodYes"
                      [value]="true"
                      [disabled]="form.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="isProbationPeriod"
                    />
                    <label class="form-check-label" for="probationPeriodYes"> Yes </label>
                    <p class="text-body-tertiary fs-12">
                      There is a probation period from Date of Joining during which there are no
                      leave accruals.
                    </p>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="probationPeriodNo"
                      [value]="false"
                      [disabled]="form.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="isProbationPeriod"
                    />
                    <label class="form-check-label" for="probationPeriodNo"> No </label>
                    <p class="text-body-tertiary fs-12">Immediately start accruing leaves.</p>
                  </div>
                  <div class="col-md-10 ms-5" *ngIf="form.get('isProbationPeriod')?.value === true">
                    <div class="mb-3">
                      <label for="waitingPeriodLength" class="form-label">
                        Waiting period length (in Days) <span class="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        formControlName="waitingPeriodLength"
                        appTrimInput
                      />
                      <div
                        *ngIf="
                          form.get('waitingPeriodLength')?.invalid &&
                          form.get('waitingPeriodLength')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('waitingPeriodLength') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="form.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Should the maximum leave balance be capped?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="maxLeaveBalanceCapYes"
                      [value]="true"
                      [disabled]="form.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="IsMaxLeaveBalanceCap"
                    />
                    <label class="form-check-label" for="maxLeaveBalanceCapYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="maxLeaveBalanceCapNo"
                      [value]="false"
                      [disabled]="form.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="IsMaxLeaveBalanceCap"
                    />
                    <label class="form-check-label" for="maxLeaveBalanceCapNo"> No </label>
                  </div>
                </div>
                <div
                  class="col-md-10 ms-5"
                  *ngIf="form.get('IsMaxLeaveBalanceCap')?.value === true"
                >
                  <div class="mb-3">
                    <label for="maxLeaveBalanceCap" class="form-label">
                      Maximum Leave Balance <span class="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="365"
                      class="form-control"
                      formControlName="maxLeaveBalanceCap"
                      appTrimInput
                    />
                    <div
                      *ngIf="
                        form.get('maxLeaveBalanceCap')?.invalid &&
                        form.get('maxLeaveBalanceCap')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getUpdateFormErrorMessage('maxLeaveBalanceCap') }}
                      </span>
                    </div>

                    <div
                      *ngIf="
                        form.hasError('maxLeaveBalanceCapLessThanTotalPerYear') &&
                        form.get('maxLeaveBalanceCap')?.touched
                      "
                      class="text-danger"
                    >
                      Max Leave Balance Cap cannot be less than Total Per Year.
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="form.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Do you want the leaves to be accrued on pro rata basis?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="accruedProRataBasisYes"
                      [value]="true"
                      [disabled]="form.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="accruedProRataBasis"
                    />
                    <label class="form-check-label" for="accruedProRataBasisYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="accruedProRataBasisNo"
                      [value]="false"
                      [disabled]="form.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="accruedProRataBasis"
                    />
                    <label class="form-check-label" for="accruedProRataBasisNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="stepChange(1)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button>
                <!-- Submit Button for COMPOFF -->
                <!-- <button
                  *ngIf="hideOtherFields; else showNext"
                  type="button"
                  (click)="onSubmit()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Submit
                </button> -->

                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>

                <!-- Next Button for other leave types -->
                <ng-template #showNext>
                  <button
                    type="button"
                    (click)="goToNextStep()"
                    [disabled]="!isStepValid()"
                    class="btn btn-primary wizard-next-btn"
                  >
                    Next
                  </button>
                </ng-template>
              </div>
            </div>
          </div>
        </fieldset>
        <!-- <ng-template *ngIf="!hideOtherFields"> -->
        <!-- <fieldset *ngIf="currentStep === 3 && !hideOtherFields" class="show-fieldset"> -->
        <fieldset *ngIf="currentStep === 3" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="resetHappen" class="col-form-label"
                      >How often should reset happen? <span class="text-danger">*</span></label
                    >
                    <p class="text-body-tertiary fs-12">
                      On the selected frequency, leave balance will get reset to a specified value.
                      AVR HRMS suggests that "Annually" is the best option.
                    </p>
                    <select class="form-select" formControlName="resetHappen">
                      <!-- <option value="Weekly">Weekly</option> -->
                      <option value="Monthly">Monthly</option>
                      <option value="Quaterly">Quaterly</option>
                      <option value="Half Yearly">Half Yearly</option>
                      <option value="Annually">Annually</option>
                    </select>

                    <div
                      *ngIf="form.get('resetHappen')?.invalid && form.get('resetHappen')?.touched"
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('resetHappen') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="resetStart" class="col-form-label"
                      >What is the start month of the reset cycle?
                      <span class="text-danger">*</span></label
                    >

                    <select class="form-select" formControlName="resetStart">
                      <option value="January">January</option>
                      <option value="February">February</option>
                      <option value="March">March</option>
                      <option value="April">April</option>
                      <option value="May">May</option>
                      <option value="June">June</option>
                      <option value="July">July</option>
                      <option value="August">August</option>
                      <option value="September">September</option>
                      <option value="October">October</option>
                      <option value="November">November</option>
                      <option value="December">December</option>
                    </select>

                    <div *ngIf="form.get('resetStart')?.invalid && form.get('resetStart')?.touched">
                      <span class="text-danger">
                        {{ getErrorMessage('resetStart') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="resetHappenPeriod" class="form-label col-lg-12"
                    >Does reset happen at the beginning or at the end of the period?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="resetHappenPeriodStart"
                      [value]="true"
                      formControlName="resetHappenPeriod"
                    />
                    <label class="form-check-label" for="resetHappenPeriodStart">
                      Beginning of the period
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="resetHappenPeriodEnd"
                      [value]="false"
                      formControlName="resetHappenPeriod"
                    />
                    <label class="form-check-label" for="resetHappenPeriodEnd">
                      End of the period
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="leavesCarryForward" class="form-label"
                    >How many days of leaves can be carried forward after every reset?
                    <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    min="0"
                    max="365"
                    class="form-control"
                    formControlName="leavesCarryForward"
                    appTrimInput
                  />
                  <div
                    *ngIf="
                      form.get('leavesCarryForward')?.invalid &&
                      form.get('leavesCarryForward')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('leavesCarryForward') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="futureResetCycle" class="form-label col-lg-12"
                    >Should leave application be allowed for a future reset cycle?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="futureResetCycleYes"
                      [value]="true"
                      formControlName="futureResetCycle"
                    />
                    <label class="form-check-label" for="futureResetCycleYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="futureResetCycleNo"
                      [value]="false"
                      formControlName="futureResetCycle"
                    />
                    <label class="form-check-label" for="futureResetCycleNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="stepChange(2)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button>
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 4" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <!-- <ng-container *ngIf="form.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="leaveAdvanceNoticePeriod" class="form-label col-lg-12">
                    Do you want employees to give advance notice before applying leave?
                  </label>
                  <p class="text-body-tertiary fs-12">
                    If yes, then enter the minimum number of days before the leave start date.
                  </p>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="leaveAdvanceNoticePeriodYes"
                      [value]="true"
                      formControlName="leaveAdvanceNoticePeriod"
                    />
                    <label class="form-check-label" for="leaveAdvanceNoticePeriodYes"> Yes </label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="leaveAdvanceNoticePeriodNo"
                      [value]="false"
                      formControlName="leaveAdvanceNoticePeriod"
                    />
                    <label class="form-check-label" for="leaveAdvanceNoticePeriodNo"> No </label>
                  </div>

                  <div
                    class="col-md-10 ms-5"
                    *ngIf="form.get('leaveAdvanceNoticePeriod')?.value === true"
                  >
                    <div class="mb-3">
                      <label for="leaveAdvanceNoticePeriodDay" class="form-label">
                        Apply Before Days <span class="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        formControlName="leaveAdvanceNoticePeriodDay"
                        appTrimInput
                      />
                      <div
                        *ngIf="
                          form.get('leaveAdvanceNoticePeriodDay')?.invalid &&
                          form.get('leaveAdvanceNoticePeriodDay')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getErrorMessage('leaveAdvanceNoticePeriodDay') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isHalfDay" class="form-label col-lg-12"
                    >Can employees apply for half day leaves?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isHalfDayYes"
                      [value]="true"
                      formControlName="isHalfDay"
                    />
                    <label class="form-check-label" for="isHalfDayYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isHalfDayNo"
                      [value]="false"
                      formControlName="isHalfDay"
                    />
                    <label class="form-check-label" for="isHalfDayNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isQuarterDay" class="form-label col-lg-12"
                    >Can employees apply for quarter day leaves?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isQuarterDayYes"
                      [value]="true"
                      formControlName="isQuarterDay"
                    />
                    <label class="form-check-label" for="isQuarterDayYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isQuarterDayNo"
                      [value]="false"
                      formControlName="isQuarterDay"
                    />
                    <label class="form-check-label" for="isQuarterDayNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="maxConsecutiveLeaves" class="form-label"
                    >Maximum Consecutive Leaves <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    formControlName="maxConsecutiveLeaves"
                    appTrimInput
                  />
                  <div
                    *ngIf="
                      form.get('maxConsecutiveLeaves')?.invalid &&
                      form.get('maxConsecutiveLeaves')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('maxConsecutiveLeaves') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isHolidayExcluded" class="form-label col-lg-12"
                    >Are holidays excluded from leave count?</label
                  >
                  <p class="text-body-tertiary fs-12">
                    If yes then any company holidays that fall on leave dates will be excluded from
                    the leave count.
                  </p>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isHolidayExcludedYes"
                      [value]="true"
                      formControlName="isHolidayExcluded"
                    />
                    <label class="form-check-label" for="isHolidayExcludedYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isHolidayExcludedNo"
                      [value]="false"
                      formControlName="isHolidayExcluded"
                    />
                    <label class="form-check-label" for="isHolidayExcludedNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isWeekendExcluded" class="form-label col-lg-12"
                    >Are weekends excluded from leave count?</label
                  >
                  <p class="text-body-tertiary fs-12">
                    If Yes then any weekends that fall on leave dates will be excluded from the
                    leave count.
                  </p>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isWeekendExcludedYes"
                      [value]="true"
                      formControlName="isWeekendExcluded"
                    />
                    <label class="form-check-label" for="isWeekendExcludedYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isWeekendExcludedNo"
                      [value]="false"
                      formControlName="isWeekendExcluded"
                    />
                    <label class="form-check-label" for="isWeekendExcludedNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="leaveTypeExclude" class="col-form-label"
                      >This leave cannot be applied together with?
                    </label>
                    <ng-select
                      class="me-3 w-100"
                      multiple
                      [items]="leaveTypes"
                      bindValue="id"
                      placeholder="Select from dropdown"
                      formControlName="leaveTypeExclude"
                      [searchable]="true"
                      [clearable]="true"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        {{ item | capitalize }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item | capitalize }}
                      </ng-template>
                    </ng-select>
                    <div
                      *ngIf="
                        form.get('leaveTypeExclude')?.invalid &&
                        form.get('leaveTypeExclude')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getErrorMessage('leaveTypeExclude') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </ng-container> -->

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isNagativeBalanceAllowed" class="form-label col-lg-12"
                    >Is negative leave balance allowed?</label
                  >
                  <p class="text-body-tertiary fs-12">
                    Even if an employee doesnt have sufficient leave balance, Will the system allow
                    the employee to create a new leave request where the manager can decide whether
                    to approve or reject ?
                  </p>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isWeekendExcludedYes"
                      [value]="true"
                      formControlName="isNagativeBalanceAllowed"
                    />
                    <label class="form-check-label" for="isWeekendExcludedYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isWeekendExcludedNo"
                      [value]="false"
                      formControlName="isNagativeBalanceAllowed"
                    />
                    <label class="form-check-label" for="isWeekendExcludedNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <!-- <button
                  type="button"
                  (click)="stepChange(3)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button> -->
                <!-- <button
                  type="button"
                  (click)="
                    stepChange(
                      form.get('accrualMethod')?.value === 'Unlimited' || hideOtherFields ? 2 : 3
                    )
                  "
                  class="btn btn-secondary wizard-prev-btn me-3"
                > -->
                <button
                  type="button"
                  (click)="stepChange(3)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button>
                <button
                  type="button"
                  (click)="onSubmit()"
                  [disabled]="!isStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  <ng-container *ngIf="isLoading; else loading">
                    <span
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submit...
                  </ng-container>
                  <ng-template #loading> Submit </ng-template>
                </button>
              </div>
            </div>
          </div>
        </fieldset>
        <!-- </ng-template> -->
      </form>
    </div>
  </div>
</ng-template>
<!-- end create leave policy -->

<!-- edit leave policy -->
<ng-template #editBusinessModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Update Leave Policy</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>

        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Accrual Rules</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 3"
          (click)="stepChange(3)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 3"
            >Reset Rules</a
          >
        </li>

        <!-- <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 4"
          (click)="stepChange(4)"
          *ngIf="!hideOtherFields"
        > -->
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 4"
          (click)="stepChange(4)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 4"
            >Application Constraints</a
          >
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <form [formGroup]="updateform">
        <fieldset *ngIf="currentStep === 1" id="first-field" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="title" class="form-label"
                    >Policy Name <span class="text-danger">*</span></label
                  >
                  <input type="text" class="form-control" formControlName="title" appTrimInput />
                  <div *ngIf="updateform.get('title')?.invalid && updateform.get('title')?.touched">
                    <span class="text-danger">
                      {{ getUpdateFormErrorMessage('title') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="description" class="form-label"
                    >Description <span class="text-danger">*</span></label
                  >
                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="description"
                    appTrimInput
                  ></textarea>
                  <div
                    *ngIf="
                      updateform.get('description')?.invalid &&
                      updateform.get('description')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getUpdateFormErrorMessage('description') }}
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="isBreakHour" class="form-label col-lg-12"
                      >Do you want the policy to be encashable?</label
                    >

                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="workhoursyes"
                        [value]="true"
                        formControlName="encashable"
                      />
                      <label class="form-check-label" for="workhoursyes"> Yes </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="workhoursno"
                        [value]="false"
                        formControlName="encashable"
                      />
                      <label class="form-check-label" for="workhoursno"> No </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isUpdateStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 2" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="accrualMethod" class="col-form-label"
                      >What is the accrual method? <span class="text-danger">*</span></label
                    >
                    <p class="text-body-tertiary fs-12">
                      Accrual refers to how many leaves are allotted every period out of the total
                      leaves allotted annually. Leaves can be earned proportionally on each pay
                      period throughout the year or all at once. AVR HRMS suggests that "throughout
                      every period" is the best option.
                    </p>
                    <select class="form-select" formControlName="accrualMethod">
                      <option value="Throughout Every Period">Throughout Every Period</option>
                      <option value="Unlimited">Unlimited</option>
                    </select>

                    <div
                      *ngIf="
                        updateform.get('accrualMethod')?.invalid &&
                        updateform.get('accrualMethod')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getUpdateFormErrorMessage('accrualMethod') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="updateform.get('accrualMetho/d')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="totalPerYear" class="form-label"
                    >Total Per Year <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    min="0"
                    max="365"
                    class="form-control"
                    formControlName="totalPerYear"
                    appTrimInput
                    [class.bg-light]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                    [class.text-muted]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                  />
                  <div
                    *ngIf="
                      updateform.get('totalPerYear')?.invalid &&
                      updateform.get('totalPerYear')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getUpdateFormErrorMessage('totalPerYear') }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="updateform.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="accrualFrequency" class="col-form-label"
                      >What do you want to be the accrual frequency?
                      <span class="text-danger">*</span></label
                    >

                    <select class="form-select" formControlName="accrualFrequency" readonly>
                      <!-- <option value="Weekly">Weekly</option> -->
                      <option value="Monthly">Monthly</option>
                      <option value="Quaterly">Quaterly</option>
                      <option value="Half Yearly">Half Yearly</option>
                      <option value="Annually">Annually</option>
                      <!-- <option>None</option> -->
                    </select>

                    <div
                      *ngIf="
                        updateform.get('accrualFrequency')?.invalid &&
                        updateform.get('accrualFrequency')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getUpdateFormErrorMessage('accrualFrequency') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="updateform.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="accrualHappenPeriod" class="form-label col-lg-12"
                    >Does accrual happen at the beginning or at the end of the period?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="accrualHappenPeriodStart"
                      [value]="true"
                      [disabled]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="accrualHappenPeriod"
                    />
                    <label class="form-check-label" for="accrualHappenPeriodStart">
                      Beginning of the period
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="accrualHappenPeriodEnd"
                      [value]="false"
                      [disabled]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="accrualHappenPeriod"
                    />
                    <label class="form-check-label" for="accrualHappenPeriodEnd">
                      End of the period
                    </label>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="updateform.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Is there a waiting period before leaves starts accruing?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="probationPeriodYes"
                      [value]="true"
                      [disabled]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="isProbationPeriod"
                    />
                    <label class="form-check-label" for="probationPeriodYes"> Yes </label>
                    <p class="text-body-tertiary fs-12">
                      There is a probation period from Date of Joining during which there are no
                      leave accruals.
                    </p>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="probationPeriodNo"
                      [value]="false"
                      [disabled]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="isProbationPeriod"
                    />
                    <label class="form-check-label" for="probationPeriodNo"> No </label>
                    <p class="text-body-tertiary fs-12">Immediately start accruing leaves.</p>
                  </div>
                  <div
                    class="col-md-10 ms-5"
                    *ngIf="updateform.get('isProbationPeriod')?.value === true"
                  >
                    <div class="mb-3">
                      <label for="probationPeriodLength" class="form-label">
                        Waiting period length <span class="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        formControlName="probationPeriodLength"
                        appTrimInput
                      />
                      <div
                        *ngIf="
                          updateform.get('probationPeriodLength')?.invalid &&
                          updateform.get('probationPeriodLength')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getUpdateFormErrorMessage('probationPeriodLength') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="updateform.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Should the maximum leave balance be capped?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="maxLeaveBalanceCapYes"
                      [value]="true"
                      [disabled]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="IsMaxLeaveBalanceCap"
                    />
                    <label class="form-check-label" for="maxLeaveBalanceCapYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="maxLeaveBalanceCapNo"
                      [value]="false"
                      [disabled]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="IsMaxLeaveBalanceCap"
                    />
                    <label class="form-check-label" for="maxLeaveBalanceCapNo"> No </label>
                  </div>
                </div>
                <div
                  class="col-md-10 ms-5"
                  *ngIf="updateform.get('IsMaxLeaveBalanceCap')?.value === true"
                >
                  <div class="mb-3">
                    <label for="maxLeaveBalanceCap" class="form-label">
                      Maximum Leave Balance <span class="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="365"
                      class="form-control"
                      formControlName="maxLeaveBalanceCap"
                      appTrimInput
                    />
                    <div
                      *ngIf="
                        updateform.get('maxLeaveBalanceCap')?.invalid &&
                        updateform.get('maxLeaveBalanceCap')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getUpdateFormErrorMessage('maxLeaveBalanceCap') }}
                      </span>
                    </div>
                    <div
                      *ngIf="
                        updateform.hasError('maxLeaveBalanceCapLessThanTotalPerYear') &&
                        updateform.get('maxLeaveBalanceCap')?.touched
                      "
                      class="text-danger"
                    >
                      Max Leave Balance Cap cannot be less than Total Per Year.
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-md-12" *ngIf="form.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isBreakHour" class="form-label col-lg-12"
                    >Do you want the leaves to be accrued on pro rata basis?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="accruedProRataBasisYes"
                      [value]="true"
                      [disabled]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="accruedProRataBasis"
                    />
                    <label class="form-check-label" for="accruedProRataBasisYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="accruedProRataBasisNo"
                      [value]="false"
                      [disabled]="updateform.get('accrualMethod')?.value === 'Unlimited'"
                      formControlName="accruedProRataBasis"
                    />
                    <label class="form-check-label" for="accruedProRataBasisNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="stepChange(1)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button>
                <!-- <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isUpdateStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button> -->
                <!-- Submit Button for COMPOFF -->
                <!-- <button
                  *ngIf="hideOtherFields; else showNext"
                  type="button"
                  (click)="onSubmit()"
                  [disabled]="!isUpdateStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Submit
                </button> -->

                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isUpdateStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>

                <!-- Next Button for other leave types -->
                <ng-template #showNext>
                  <button
                    type="button"
                    (click)="goToNextStep()"
                    [disabled]="!isUpdateStepValid()"
                    class="btn btn-primary wizard-next-btn"
                  >
                    Next
                  </button>
                </ng-template>
              </div>
            </div>
          </div>
        </fieldset>
        <!-- <ng-template *ngIf="!hideOtherFields"> -->
        <!-- <fieldset *ngIf="currentStep === 3 && !hideOtherFields" class="show-fieldset"> -->
        <fieldset *ngIf="currentStep === 3">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="resetHappen" class="col-form-label"
                      >How often should reset happen? <span class="text-danger">*</span></label
                    >
                    <p class="text-body-tertiary fs-12">
                      On the selected frequency, leave balance will get reset to a specified value.
                      AVR HRMS suggests that "Annually" is the best option.
                    </p>
                    <select class="form-select" formControlName="resetHappen">
                      <!-- <option value="Weekly">Weekly</option> -->
                      <option value="Monthly">Monthly</option>
                      <option value="Quaterly">Quaterly</option>
                      <option value="Half Yearly">Half Yearly</option>
                      <option value="Annually">Annually</option>
                    </select>

                    <div
                      *ngIf="
                        updateform.get('resetHappen')?.invalid &&
                        updateform.get('resetHappen')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getUpdateFormErrorMessage('resetHappen') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="resetStart" class="col-form-label"
                      >What is the start month of the reset cycle?
                      <span class="text-danger">*</span></label
                    >

                    <select class="form-select" formControlName="resetStart">
                      <option value="January">January</option>
                      <option value="February">February</option>
                      <option value="March">March</option>
                      <option value="April">April</option>
                      <option value="May">May</option>
                      <option value="June">June</option>
                      <option value="July">July</option>
                      <option value="August">August</option>
                      <option value="September">September</option>
                      <option value="October">October</option>
                      <option value="November">November</option>
                      <option value="December">December</option>
                    </select>

                    <div
                      *ngIf="
                        updateform.get('resetStart')?.invalid &&
                        updateform.get('resetStart')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getUpdateFormErrorMessage('resetStart') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="resetHappenPeriod" class="form-label col-lg-12"
                    >Does reset happen at the beginning or at the end of the period?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="resetHappenPeriodStart"
                      [value]="true"
                      formControlName="resetHappenPeriod"
                    />
                    <label class="form-check-label" for="resetHappenPeriodStart">
                      Beginning of the period
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="resetHappenPeriodEnd"
                      [value]="false"
                      formControlName="resetHappenPeriod"
                    />
                    <label class="form-check-label" for="resetHappenPeriodEnd">
                      End of the period
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="leavesCarryForward" class="form-label"
                    >How many days of leaves can be carried forward after every reset?
                    <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    min="0"
                    max="365"
                    class="form-control"
                    formControlName="leavesCarryForward"
                    appTrimInput
                  />
                  <div
                    *ngIf="
                      updateform.get('leavesCarryForward')?.invalid &&
                      updateform.get('leavesCarryForward')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getUpdateFormErrorMessage('leavesCarryForward') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="futureResetCycle" class="form-label col-lg-12"
                    >Should leave application be allowed for a future reset cycle?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="futureResetCycleYes"
                      [value]="true"
                      formControlName="futureResetCycle"
                    />
                    <label class="form-check-label" for="futureResetCycleYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="futureResetCycleNo"
                      [value]="false"
                      formControlName="futureResetCycle"
                    />
                    <label class="form-check-label" for="futureResetCycleNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="stepChange(2)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button>
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!isUpdateStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 4" class="show-fieldset">
          <div class="contact-input-set">
            <div class="row">
              <!-- <ng-container *ngIf="updateform.get('accrualMethod')?.value !== 'Unlimited'"> -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="leaveAdvanceNoticePeriod" class="form-label col-lg-12">
                    Do you want employees to give advance notice before applying leave?
                  </label>
                  <p class="text-body-tertiary fs-12">
                    If yes, then enter the minimum number of days before the leave start date.
                  </p>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="leaveAdvanceNoticePeriodYes"
                      [value]="true"
                      formControlName="leaveAdvanceNoticePeriod"
                    />
                    <label class="form-check-label" for="leaveAdvanceNoticePeriodYes"> Yes </label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="leaveAdvanceNoticePeriodNo"
                      [value]="false"
                      formControlName="leaveAdvanceNoticePeriod"
                    />
                    <label class="form-check-label" for="leaveAdvanceNoticePeriodNo"> No </label>
                  </div>

                  <div
                    class="col-md-10 ms-5"
                    *ngIf="updateform.get('leaveAdvanceNoticePeriod')?.value === true"
                  >
                    <div class="mb-3">
                      <label for="leaveAdvanceNoticePeriodDay" class="form-label">
                        Apply Before Days <span class="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        formControlName="leaveAdvanceNoticePeriodDay"
                        appTrimInput
                      />
                      <div
                        *ngIf="
                          updateform.get('leaveAdvanceNoticePeriodDay')?.invalid &&
                          updateform.get('leaveAdvanceNoticePeriodDay')?.touched
                        "
                      >
                        <span class="text-danger">
                          {{ getUpdateFormErrorMessage('leaveAdvanceNoticePeriodDay') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isHalfDay" class="form-label col-lg-12"
                    >Can employees apply for half day leaves?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isHalfDayYes"
                      [value]="true"
                      formControlName="isHalfDay"
                    />
                    <label class="form-check-label" for="isHalfDayYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isHalfDayNo"
                      [value]="false"
                      formControlName="isHalfDay"
                    />
                    <label class="form-check-label" for="isHalfDayNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isQuarterDay" class="form-label col-lg-12"
                    >Can employees apply for quarter day leaves?</label
                  >

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isQuarterDayYes"
                      [value]="true"
                      formControlName="isQuarterDay"
                    />
                    <label class="form-check-label" for="isQuarterDayYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isQuarterDayNo"
                      [value]="false"
                      formControlName="isQuarterDay"
                    />
                    <label class="form-check-label" for="isQuarterDayNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="maxConsecutiveLeaves" class="form-label"
                    >Maximum Consecutive Leaves <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    formControlName="maxConsecutiveLeaves"
                    appTrimInput
                  />
                  <div
                    *ngIf="
                      updateform.get('maxConsecutiveLeaves')?.invalid &&
                      updateform.get('maxConsecutiveLeaves')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getUpdateFormErrorMessage('maxConsecutiveLeaves') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isHolidayExcluded" class="form-label col-lg-12"
                    >Are holidays excluded from leave count?</label
                  >
                  <p class="text-body-tertiary fs-12">
                    If yes then any company holidays that fall on leave dates will be excluded from
                    the leave count.
                  </p>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isHolidayExcludedYes"
                      [value]="true"
                      formControlName="isHolidayExcluded"
                    />
                    <label class="form-check-label" for="isHolidayExcludedYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isHolidayExcludedNo"
                      [value]="false"
                      formControlName="isHolidayExcluded"
                    />
                    <label class="form-check-label" for="isHolidayExcludedNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isWeekendExcluded" class="form-label col-lg-12"
                    >Are weekends excluded from leave count?</label
                  >
                  <p class="text-body-tertiary fs-12">
                    If Yes then any weekends that fall on leave dates will be excluded from the
                    leave count.
                  </p>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isWeekendExcludedYes"
                      [value]="true"
                      formControlName="isWeekendExcluded"
                    />
                    <label class="form-check-label" for="isWeekendExcludedYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isWeekendExcludedNo"
                      [value]="false"
                      formControlName="isWeekendExcluded"
                    />
                    <label class="form-check-label" for="isWeekendExcludedNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <div class="input-block mb-3">
                    <label for="leaveTypeExclude" class="col-form-label"
                      >This leave cannot be applied together with?
                    </label>
                    <ng-select
                      class="me-3 w-100"
                      multiple
                      [items]="leaveTypes"
                      bindValue="id"
                      placeholder="Select from dropdown"
                      formControlName="leaveTypeExclude"
                      [searchable]="true"
                      [clearable]="true"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        {{ item | capitalize }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item | capitalize }}
                      </ng-template>
                    </ng-select>
                    <div
                      *ngIf="
                        updateform.get('leaveTypeExclude')?.invalid &&
                        updateform.get('leaveTypeExclude')?.touched
                      "
                    >
                      <span class="text-danger">
                        {{ getUpdateFormErrorMessage('leaveTypeExclude') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </ng-container> -->

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="isNagativeBalanceAllowed" class="form-label col-lg-12"
                    >Is negative leave balance allowed?</label
                  >
                  <p class="text-body-tertiary fs-12">
                    Even if an employee doesnt have sufficient leave balance, Will the system allow
                    the employee to create a new leave request where the manager can decide whether
                    to approve or reject ?
                  </p>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isWeekendExcludedYes"
                      [value]="true"
                      formControlName="isNagativeBalanceAllowed"
                    />
                    <label class="form-check-label" for="isWeekendExcludedYes"> Yes </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="isWeekendExcludedNo"
                      [value]="false"
                      formControlName="isNagativeBalanceAllowed"
                    />
                    <label class="form-check-label" for="isWeekendExcludedNo"> No </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <!-- <button
                  type="button"
                  (click)="stepChange(3)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                > -->
                <!-- <button
                  type="button"
                  (click)="
                    stepChange(
                      updateform.get('accrualMethod')?.value === 'Unlimited' ||
                        'Throughout Every Period'
                        ? 2
                        : 3
                    )
                  "
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button> -->
                <!-- <button
                  type="button"
                  (click)="
                    stepChange(
                      updateform.get('accrualMethod')?.value === 'Unlimited' || hideOtherFields
                        ? 2
                        : 3
                    )
                  "
                  class="btn btn-secondary wizard-prev-btn me-3"
                > -->
                <button
                  type="button"
                  (click)="stepChange(3)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button>
                <button
                  type="button"
                  (click)="onSubmit()"
                  [disabled]="!isUpdateStepValid()"
                  class="btn btn-primary wizard-next-btn"
                >
                  <ng-container *ngIf="isLoading; else loading">
                    <span
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submit...
                  </ng-container>
                  <ng-template #loading> Submit </ng-template>
                </button>
              </div>
            </div>
          </div>
        </fieldset>
        <!-- </ng-template> -->
      </form>
    </div>
  </div>
</ng-template>
<!-- end edit leave policy -->

<!-- assign leave policy -->
<ng-template #assignPolicyModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign Leave Policy</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="assignLeavePolicyform">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="businessId" class="col-form-label"
                >Business Entity <span class="text-danger">*</span></label
              >
              <!-- <select
                class="form-select"
                formControlName="businessId"
                (change)="onChangePolicyList($event.target)"
              >
                <option value="" selected disabled>Select Business Entity</option>
                <option *ngFor="let business of businesses$ | async" [value]="business.id">
                  {{ business.businessName | capitalize }}
                </option>
              </select> -->
              <ng-select
                class="me-3 w-100"
                [items]="businesses$ | async"
                bindValue="id"
                placeholder="Select Business Entity"
                formControlName="businessId"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFn"
                style="width: 200px"
                [(ngModel)]="selectedBusinessId"
                (change)="onChangePolicyList($event.target)"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  assignLeavePolicyform.get('businessId')?.invalid &&
                  assignLeavePolicyform.get('businessId')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('businessId') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="leavePolicyId" class="col-form-label"
                >Leave Policy <span class="text-danger">*</span></label
              >
              <select
                class="form-select"
                formControlName="leavePolicyId"
                (change)="onChangeEmployeeList($event.target)"
              >
                <option value="" selected disabled>Select Leave Policy</option>
                <!-- <option *ngFor="let policy of policyList" [value]="policy.id"> -->
                <option *ngFor="let policy of modalPolicyList" [value]="policy.id">
                  {{ policy.title | capitalize }}
                </option>
              </select>
              <div
                *ngIf="
                  assignLeavePolicyform.get('leavePolicyId')?.invalid &&
                  assignLeavePolicyform.get('leavePolicyId')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('leavePolicyId') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="employeeIds" class="col-form-label"
                >Employees <span class="text-danger">*</span></label
              >
              <!-- <div formArrayName="employeeIds"> -->
              <!-- <select class="js-select2 form-select" multiple (change)="onEmployeeSelect($event)">
                  <option *ngFor="let employee of employeeList" [value]="employee.id">
                    {{ employee.firstName | capitalize }}
                  </option>
                </select> -->
              <ng-select
                class="me-3 w-100"
                multiple
                [items]="employeeList"
                bindValue="id"
                placeholder="Select Employee"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFnEmployee"
                style="width: 200px"
                formControlName="employeeIds"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
              </ng-select>
              <!-- </div> -->
              <div
                *ngIf="
                  assignLeavePolicyform.get('employeeIds')?.invalid &&
                  assignLeavePolicyform.get('employeeIds')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('employeeIds') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="onAssign()"
        [disabled]="assignLeavePolicyform.invalid"
      >
        Assign
      </button>
    </div>
  </form>
</ng-template>

<!-- assign leave policy end -->

<!-- block unblock Modal -->
<ng-template #blockunblockModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span
      class="avatar avatar-xl mb-3"
      [ngClass]="
        blockUnblockStatus !== 'Active'
          ? 'bg-transparent-danger text-danger'
          : 'bg-transparent-success text-success'
      "
    >
      <i
        [ngClass]="blockUnblockStatus !== 'Active' ? 'ti ti-lock fs-36' : 'ti ti-lock-open-2 fs-36'"
      ></i>
    </span>
    <h4 class="mb-1">Confirm {{ blockUnblockStatus }}</h4>
    <p class="mb-3">
      You want to {{ blockUnblockStatus !== 'Active' ? 'inactive' : 'active' }} the
      <strong>{{ blockTilte }}</strong
      >.
    </p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmBlockUnblock()"
        >Yes, {{ blockUnblockStatus !== 'Active' ? 'Inactive' : 'Active' }}</a
      >
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /block unblock Modal -->

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">You want to delete the leave policy, this can't be undone once you delete.</p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmDelete()">Yes, Delete</a>
    </div>
  </div>
  <!-- </div>
  </div>
  </div> -->
</ng-template>
<!-- /Delete Modal -->
